import type { RouteObject } from 'react-router-dom'
import { Outlet } from 'react-router-dom'

import { ErrorElement } from '@jotta/ui/ErrorElement'
import { ErrorPage } from '@jotta/ui/ErrorPage'
import { LoadingOverlay } from '@jotta/ui/LoadingOverlay'

import { addPhotosLoader } from '../api/addPhotos.loader'
import { followAlbumLoader } from '../api/followAlbum.loader'
import { PublicAlbumRoute } from '../components/Album/Album/PublicAlbum.route'
import { publicAlbumInfoLoader } from '../components/Album/AlbumInfo/AlbumInfo.loaders'
import { PhotoLayout } from '../components/PhotoLayout/PhotoLayout'
import { PhotoRouteId } from '../routes/photoRouteIds'

export const SharedPhotosRoute: RouteObject = {
  id: PhotoRouteId.PhotosPublicAlbumInfoLoader,
  path: 'share',
  loader: publicAlbumInfoLoader,
  errorElement: (
    <ErrorElement
      captureContext={scope => scope.setTag('key', 'sharedphotosroute')}
    />
  ),
  children: [
    {
      index: true,
      element: <ErrorPage notFound />,
    },
    {
      id: PhotoRouteId.PhotosShare,
      path: ':shareId',
      element: <PhotoLayout isPublic />,
      children: [
        {
          id: PhotoRouteId.PhotosShareMediaId,
          path: '',
          element: <PublicAlbumRoute />,
          children: [
            {
              path: ':mediaId',
              element: <Outlet />,
            },
          ],
        },
      ],
    },
    {
      id: PhotoRouteId.PhotosShareActionAddPhotos,
      path: ':shareId/addphotos',
      loader: addPhotosLoader,
      element: <LoadingOverlay id="SharedPhotosRoute.AddPhotos" open />,
    },
    {
      id: PhotoRouteId.PhotosShareActionFollowAlbum,
      path: ':shareId/follow',
      loader: followAlbumLoader,
      element: <LoadingOverlay id="SharedPhotosRoute.Follow" open />,
    },
  ],
}
